<template>
    <v-expansion-panel v-if="panel" class="emc-selectable-list">
        <v-expansion-panel-header class="px-3 py-0 emc-selectable-list__header">
            <div class="d-flex align-center" style="gap: 8px">
                <v-icon v-if="icon" small>{{ icon }}</v-icon>
                <span class="text-body-2 font-weight-medium">{{ label }}</span>
                <v-spacer />
                <v-chip x-small label outlined color="primary" class="flex-grow-0 mr-2">
                    {{ selectedCount }} / {{ items.length }}
                </v-chip>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div class="emc-selectable-list__body">
                <div
                    v-if="(selectAll && !disabled) || searchable"
                    class="d-flex align-center pt-2"
                    style="gap: 8px"
                >
                    <v-text-field
                        v-if="searchable"
                        v-model="search"
                        dense
                        outlined
                        hide-details
                        clearable
                        prepend-inner-icon="mdi-magnify"
                        :label="searchLabel"
                        :disabled="disabled"
                    />
                    <v-spacer v-else />
                    <a
                        v-if="selectAll && !disabled"
                        class="text-caption primary--text text-no-wrap"
                        @click.prevent="toggleAll"
                    >
                        {{ allSelected ? 'Limpar' : 'Todos' }}
                    </a>
                </div>

                <slot name="filter" />

                <v-progress-linear v-if="loading" indeterminate color="primary" class="mt-1" />

                <p v-if="hasError" class="text-center red--text text-caption mb-0 mt-1">{{ errors[0] }}</p>

                <emc-util-scroll :height="height">
                    <v-list dense class="py-0">
                        <template v-if="displayItems.length">
                            <v-list-item
                                v-for="item in displayItems"
                                :key="item[itemValue]"
                                :disabled="disabled"
                                :input-value="isSelected(item)"
                                active-class="primary--text"
                                @click="toggle(item)"
                            >
                                <v-list-item-action class="mr-3 my-0">
                                    <v-icon :color="isSelected(item) ? 'primary' : 'grey lighten-1'">
                                        {{ isSelected(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item[itemText] }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="!!$scopedSlots.subtitle">
                                        <slot name="subtitle" :item="item" />
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action v-if="!!$scopedSlots.meta" class="my-0">
                                    <v-list-item-action-text class="text-right">
                                        <slot name="meta" :item="item" />
                                    </v-list-item-action-text>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                        <v-list-item v-else-if="!loading">
                            <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text text-center">
                                    Nenhum item encontrado
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </emc-util-scroll>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-sheet v-else outlined rounded class="emc-selectable-list">

        <div class="d-flex align-center px-3 py-1 emc-selectable-list__header">
            <v-icon v-if="icon" x-small class="mr-2">{{ icon }}</v-icon>
            <span class="text-caption font-weight-medium">{{ label }}</span>
            <v-spacer />
            <a
                v-if="selectAll && !disabled"
                class="text-caption mr-3 primary--text"
                @click.prevent="toggleAll"
            >
                {{ allSelected ? 'Limpar' : 'Todos' }}
            </a>
            <v-chip x-small label outlined color="primary">{{ selectedCount }} / {{ items.length }}</v-chip>
        </div>

        <div v-if="searchable" class="px-3 pt-2">
            <v-text-field
                v-model="search"
                dense
                outlined
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                :label="searchLabel"
                :disabled="disabled"
            />
        </div>

        <slot name="filter" />

        <v-progress-linear v-if="loading" indeterminate color="primary" class="mt-1" />

        <p v-if="hasError" class="text-center red--text text-caption mb-0 mt-1">{{ errors[0] }}</p>

        <emc-util-scroll :height="height">
            <v-list dense class="py-0">
                <template v-if="displayItems.length">
                    <v-list-item
                        v-for="item in displayItems"
                        :key="item[itemValue]"
                        :disabled="disabled"
                        :input-value="isSelected(item)"
                        active-class="primary--text"
                        @click="toggle(item)"
                    >
                        <v-list-item-action class="mr-3 my-0">
                            <v-icon :color="isSelected(item) ? 'primary' : 'grey lighten-1'">
                                {{ isSelected(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ item[itemText] }}</v-list-item-title>
                            <v-list-item-subtitle v-if="!!$scopedSlots.subtitle">
                                <slot name="subtitle" :item="item" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if="!!$scopedSlots.meta" class="my-0">
                            <v-list-item-action-text class="text-right">
                                <slot name="meta" :item="item" />
                            </v-list-item-action-text>
                        </v-list-item-action>
                    </v-list-item>
                </template>
                <v-list-item v-else-if="!loading">
                    <v-list-item-content>
                        <v-list-item-title class="text-caption grey--text text-center">
                            Nenhum item encontrado
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </emc-util-scroll>
    </v-sheet>
</template>

<script>
import { ref, computed } from 'vue'

export default {
    name: 'EmcSelectableList',
    props: {
        items: {
            type: Array,
            required: true,
        },
        model: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
        selectAll: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        searchLabel: {
            type: String,
            default: 'Buscar...',
        },
        itemText: {
            type: String,
            default: 'name',
        },
        itemValue: {
            type: String,
            default: 'id',
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Array,
            default: () => [],
        },
        height: {
            type: String,
            default: '28vh',
        },
        panel: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const search = ref('')

        const norm = (value) => (value === null || value === undefined ? value : String(value))

        const keyOf = (value) =>
            value !== null && typeof value === 'object' ? value[props.itemValue] : value

        const selectedKeys = computed(() => (props.model || []).map((v) => norm(keyOf(v))))

        const isSelected = (item) => selectedKeys.value.includes(norm(item[props.itemValue]))

        const displayItems = computed(() => {
            const term = (search.value || '').trim().toLowerCase()

            if (!term) {
                return props.items
            }

            return props.items.filter((i) =>
                String(i[props.itemText] || '').toLowerCase().includes(term)
            )
        })

        const selectedCount = computed(() => props.items.filter(isSelected).length)

        const allSelected = computed(
            () => displayItems.value.length > 0 && displayItems.value.every(isSelected)
        )

        const hasError = computed(() => props.errors && props.errors.length > 0)

        const valueOf = (item) => (props.returnObject ? item : item[props.itemValue])

        const toggle = (item) => {
            if (props.disabled) {
                return
            }

            const current = [...(props.model || [])]
            const idx = current.findIndex((v) => norm(keyOf(v)) === norm(item[props.itemValue]))

            if (idx >= 0) {
                current.splice(idx, 1)
            } else {
                current.push(valueOf(item))
            }

            emit('update:model', current)
        }

        const toggleAll = () => {
            if (props.disabled) {
                return
            }

            const visibleKeys = displayItems.value.map((i) => norm(i[props.itemValue]))

            if (allSelected.value) {
                emit(
                    'update:model',
                    (props.model || []).filter((v) => !visibleKeys.includes(norm(keyOf(v))))
                )
                return
            }

            const current = [...(props.model || [])]

            displayItems.value.forEach((i) => {
                if (!selectedKeys.value.includes(norm(i[props.itemValue]))) {
                    current.push(valueOf(i))
                }
            })

            emit('update:model', current)
        }

        return {
            search,
            isSelected,
            displayItems,
            selectedCount,
            allSelected,
            hasError,
            toggle,
            toggleAll,
        }
    },
}
</script>
